<template>
    <div class="card" :class="{ 'premium-card': plan === 'premium' }">
        <div class="tyoeStatus">
            <div class="date-title">
                <div class="month">{{ date.month }}</div>
                <div class="day">
                    <span class="day-number">{{ date.dayNumber }}</span>
                    <span class="day-text">{{ date.dayText }}</span>
                </div>
            </div>
        </div>
        <h2 class="card-title">{{ title }}</h2>
        <p class="card-content">{{ content }}</p>
        <div style="text-align: justify;" v-html="description">

        </div>
        <div class="duration">
            <div>
                <h2>Duration</h2>
                <p>{{ duration}}</p>
            </div>
            <div>
                <h2>Capacity</h2>
                <p>{{ capacity}}</p>
            </div>
        </div>
        <!-- <div class="price">
            <button class="view-details">View Details</button>
        </div> -->
    </div>
</template>

<script setup>
/* eslint-disable */
defineProps({
    title: {
        type: String,
        required: true
    },
    content: {
        type: String,
        default: ""
    },
    plan: {
        type: String,
        default: ""
    },
    description: {
        type: String,
        default: ""
    },
    duration: {
        type: String,
        default: ""
    },
    capacity: {
        type: String,
        default: ""
    },
    month: {
        type: String,
        default: ""
    },
    day: {
        type: String,
        default: ""
    },
    week: {
        type: String,
        default: ""
    },
    date: {
    type: Object,
    required: true
  }
});
</script>

<style lang="scss" scoped>

.premium-card {
    background-color: #094923;
    color: white;
}

.card {
    width: auto;
    border: 1px solid #77787833;
    border-radius: 20px;
    padding: 0rem 4rem;
    margin: 10px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: start;
    background: #072a08;
    color: #fff;

    .tyoeStatus {
        display: flex;
        justify-content: end;
        align-items: end;
        width: 100%;

        .date-title {
            top: 100%;
            width: 117px;
            height: 130px;
            opacity: 1;
            border-bottom-right-radius: 10px;
            border-bottom-left-radius: 10px;
            padding: 10px;
            background: #094923;
            border-bottom: 1px solid #fff;
            border-left: 1px solid #fff;
            border-right: 1px solid #fff;
        }
        .month{
            width: 97px;
            height: 30px;
            opacity: 1;
            padding-top: 0px;
            padding-bottom: 6px;
            gap: 10px;
            color: #fff;
            font-weight: 400;
            font-style: Regular;
            font-size: 14px;
            text-align: center;
        }
        .day{
            display: flex;
            flex-direction: column;
            width: 97px;
            height: 70px;
            opacity: 1;
            padding-top: 12px;
            padding-right: 30px;
            padding-bottom: 12px;
            padding-left: 30px;
            border-bottom-right-radius: 10px;
            border-bottom-left-radius: 10px;
            background: #ED4E24;
            ;

            .day-number{
                font-weight: 600;
                font-style: Semibold;
                font-size: 17px;
                color: #fff;
            }

            .day-text{
                font-weight: 400;
                font-style: Semibold;
                font-size: 13px;
                color: #fff;
            }

        }
    }

    ul {
        padding: 20px;

        li {
            padding: 5px 0;
            text-align: left;
            font-size: 16px;
            /* color: #555555; */
            font-weight: 400;
            font-family: "Open Runde", sans-serif;
            text-align: left;
        }
    }

    .card-title {
        font-size: 26px;
        /* color: #000000; */
        font-weight: 500;
        margin: 10px 0;
        font-family: "Open Runde", sans-serif;
        text-align: left;
    }

    .card-content {
        font-size: 16px;
        /* color: #555555; */
        font-weight: 400;
        font-family: "Open Runde", sans-serif;
        text-align: left;
    }

    .price {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 0 0 1.5rem;
    }
    .view-details {
        width: 100%;
        height: 64px;
        border-radius: 60px;
        padding-top: 20px;
        padding-right: 10px;
        padding-bottom: 20px;
        padding-left: 10px;
        background: #FFFFFF;
        border: 1px solid;
        font-weight: 400;
        font-style: Regular;
        font-size: 16px;
    }

    @media (max-width: 768px) {

    .view-details {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        height: 50px;
     }
    }

    .duration {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 2rem 0;
        border-top: 1px solid #00000033;

        div {
            display: flex;
            flex-direction: column;
            justify-content: start;
            align-items: start;

            h2 {
                font-size: 16px;
                /* color: #000000; */
                font-weight: 500;
                font-family: "Open Runde", sans-serif;
                text-align: left;
            }

            p {
                font-size: 14px;
                /* color: #494949; */
                font-weight: 400;
                font-family: "Open Runde", sans-serif;
                text-align: left;
            }
        }
    }
}

@media (max-width: 768px) {
    .card {
        width: 100%;
        margin: 0px;
        padding: 0rem 1.4rem;
    }
}
</style>
